import StyleNameHeader from './StyleNameHeader';
import LayoutBox from './LayoutBox';
import StylePanelMixin from '../utils/StylePanelMixin';
const __script_base__ = {
  name: 'SPCssBox',
  extends: StylePanelMixin,
  inject: ['showPanelName'],
  components: {
    StyleNameHeader,
    LayoutBox
  },
  methods: {
    childrenCommitStyle(style) {
      this.style = Object.assign({}, this.style, {
        ...style
      });
    },
    resetStyle(field) {
      switch (field) {
        case 'margin':
          this.deleteStyle('marginTop');
          this.deleteStyle('marginRight');
          this.deleteStyle('marginBottom');
          this.deleteStyle('marginLeft');
          break;
        case 'padding':
          this.deleteStyle('paddingTop');
          this.deleteStyle('paddingRight');
          this.deleteStyle('paddingBottom');
          this.deleteStyle('paddingLeft');
          break;
        case 'width':
          this.deleteStyle('width');
          break;
        case 'height':
          this.deleteStyle('height');
          break;
        case 'content':
          this.deleteStyle('width');
          this.deleteStyle('height');
          break;
        default:
      }
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("styleNameHeader", {
    attrs: {
      name: "内外边距 | 高宽 (px)"
    },
    scopedSlots: _vm._u([{
      key: "operation",
      fn: function () {
        return [_c("div", {
          staticClass: "uc-style-name-header-operations"
        }, [_c("i", {
          staticClass: "fa fa-undo uc-inputbox-reset-button content",
          on: {
            click: function ($event) {
              return _vm.resetStyle("content");
            }
          }
        }), _vm._v(" "), _c("div", {
          staticClass: "uc-inputbox-reset-tip"
        }, [_vm._v("\n        重置高宽\n      ")])]), _vm._v(" "), _c("div", {
          staticClass: "uc-style-name-header-operations"
        }, [_c("i", {
          staticClass: "fa fa-undo uc-inputbox-reset-button padding",
          on: {
            click: function ($event) {
              return _vm.resetStyle("padding");
            }
          }
        }), _vm._v(" "), _c("div", {
          staticClass: "uc-inputbox-reset-tip"
        }, [_vm._v("\n        重置内边距\n      ")])]), _vm._v(" "), _c("div", {
          staticClass: "uc-style-name-header-operations"
        }, [_c("i", {
          staticClass: "fa fa-undo uc-inputbox-reset-button margin",
          on: {
            click: function ($event) {
              return _vm.resetStyle("margin");
            }
          }
        }), _vm._v(" "), _c("div", {
          staticClass: "uc-inputbox-reset-tip"
        }, [_vm._v("\n        重置外边距\n      ")])])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c("LayoutBox", {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      _style: _vm.style,
      "show-panel-name": this.showPanelName
    },
    on: {
      commitstyle: _vm.childrenCommitStyle
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/StylePanel/comps/cssBox.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);